import styled from 'styled-components'

import { Button } from '@blade/ui-kit'

import { ReservedSpace } from '../reserved-space/reserved-space'

import type { ButtonProps } from '@blade/ui-kit'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  counter: number
  text: string
} & ButtonProps &
  ClassNameProps

export const DataCounterButton: React.FC<Props> = ({
  className,
  counter,
  text,
  ...props
}) => {
  return (
    <Root
      className={className}
      variant="soft"
      size="xxs"
      radius="rounded"
      {...props}
    >
      <ReservedSpace $chars={counter.toString().length}>
        <SquareCounter>{counter}</SquareCounter>
      </ReservedSpace>
      {text}
    </Root>
  )
}

const Root = styled(Button)`
  --button-radius-rounded: 4px;

  background: var(--amberA-3);
  color: var(--amber-9);

  border-radius: 6px;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.17);
  backdrop-filter: blur(6px);
  pointer-events: all;

  gap: 4px;
  padding: 4px;
  padding-inline-end: 6px;
  border-radius: 6px;
  font-size: 10px;

  transition: all 0.2s ease-in-out;
  font-weight: 500;

  svg {
    margin-top: 1px;
  }

  &:hover {
    background: var(--amberA-4);
    color: var(--amber-9);
  }
`

const SquareCounter = styled.span`
  background: var(--amberA-9);
  color: var(--text-1);

  font-weight: 700;
  line-height: 16px;
  border-radius: 2px;
  font-size: 8px;
  line-height: 1;
  padding: 2px;
  height: 18px;
  min-width: 18px;

  display: grid;
  place-items: center;
  transition: all 0.15s linear;

  &[aria-expanded='true'] {
    background: var(--amberA-8);
  }
`
